import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import MetaProperty from "components/MetaProperties/MetaProperty";
import { transform, fromPairs } from "lodash";

export default function EntryEditor(props) {
    const [formValues, setFormValues] = useState({});

    const onSubmit = (values) => {
        // unzip it all back into a single object
        const allKeys = fromPairs(
            props.channel?.meta.map((meta) => [
                meta.slug,
                {
                    channel_meta_id: meta.id,
                    slug: meta.slug,
                    value: null,
                    channel_uuid: meta.uuid,
                    type: meta.type,
                },
            ])
        );

        const parsedValues = transform(
            allKeys,
            (result, value, key) => {
                const val = props.entry?.meta.find((meta) => meta.slug === key);
                result[key] = Object.assign({}, value, val, {
                    value: values[key],
                });
            },
            {}
        );

        props.onSubmit(parsedValues, values);
    };

    useEffect(() => {
        const allKeys = fromPairs(
            props.channel?.meta.map((meta) => [meta.slug, ""])
        );
        const vals = transform(
            allKeys,
            (result, value, key) => {
                const val = props.entry?.meta.find((meta) => meta.slug === key);
                result[key] = val ? val.value : value;
            },
            {}
        );
        setFormValues(vals);
    }, [props.entry, props.channel]);

    return (
        <Formik
            initialValues={formValues}
            enableReinitialize={true}
            onSubmit={onSubmit}
        >
            <Form className={props.className}>
                {props.children(
                    props.channel?.meta.map((metaProp, index) => (
                        <div key={index}>
                            <MetaProperty
                                type={metaProp.type}
                                label={metaProp.label}
                                field={metaProp.slug}
                                nameMask="{field}"
                            />
                        </div>
                    ))
                )}
            </Form>
        </Formik>
    );
}
